
import { authHeader } from '../helpers';
import store from '@/store';

export const apiService = {
  getShipments,
  updateShipment,
  getFaqs,
  getFaqTopics,
  addFaq,
  deleteFaq,
  addArt,
  updateArt,
  approvePiece,
  declinePiece,
  setSortIndex,
  suspendArtist,
  declineArtist,
  approveArtist,
  removeArtist,
  getAddresses,
  getArtistBankAccount,
  sendAccountReminder,
  getArt,
  getPiece,
  getArtist,
  getArtists,
  getDashboard,
  getOrders,
  getOrder,
  getShipment,
  getReport,
  getOrderLine,
  getOrderLines,
  confirmOrderLine,
  addCustomer,
  getCustomer,
  getCustomers,
  getRental,
  getRentals,
  getPayoutsEligible,
  getPayoutEligible,
  getPayouts,
  getPayout,
  addPayout,
  completeOrder,
  addReturn,
  updatePayoutPop,
  addItem,
  deletePiece,
  updateItem,
  getItems,
  wasteMyTime,
  reportFault,
  addOrder,
  addCorporateRental,
  cancelRental,
  returnRental,
  convertRental,
  toggleFeaturedArtist,
  getArtistAddress,
  cancelOrder,
  cancelShipment,
};
// Item functions
function getShipments(orderId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/shipment${orderId ? `?order=${orderId}` : ''}`, requestOptions).then(handleResponse);
}
function getArtistBankAccount(artistId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist/${artistId}/bank-account`, requestOptions).then(handleResponse);
}
function getArtistAddress(artistId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist/${artistId}/address`, requestOptions).then(handleResponse);
}
function getArt(filter) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  let statusString = '';
  if (filter.status) {
    statusString = filter.status.join('&status[]=');
  }
  return fetch(`
  ${process.env.ROOT_API}/art?&artist_id=${filter.artist_id || ''}${statusString ? `&status[]=${statusString}` : ''}&is_test=${filter.is_test || ''}`,
  requestOptions).then(handleResponse);
}
function getPiece(pieceId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/art/${pieceId}`, requestOptions).then(handleResponse);
}
function sendAccountReminder(artistId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist/${artistId}/send-account-reminder`, requestOptions).then(handleResponse);
}
function approvePiece(pieceId) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/art/${pieceId}/approve`, requestOptions).then(handleResponse);
}
function declinePiece(pieceId) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/art/${pieceId}/decline`, requestOptions).then(handleResponse);
}
function setSortIndex(pieceId, sortIndex) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ sort_index: sortIndex }),
  };
  return fetch(`${process.env.ROOT_API}/art/${pieceId}/sort_index`, requestOptions).then(handleResponse);
}
function toggleFeaturedArtist(artistId) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ artist_id: artistId }),
  };
  return fetch(`${process.env.ROOT_API}/artist/${artistId}/featured`, requestOptions).then(handleResponse);
}
function approveArtist(artistId) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist/${artistId}/approve`, requestOptions).then(handleResponse);
}
function removeArtist(artistId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist/${artistId}/remove`, requestOptions).then(handleResponse);
}
function suspendArtist(artistId) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist/${artistId}/suspend`, requestOptions).then(handleResponse);
}
function declineArtist(artistId) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist/${artistId}/decline`, requestOptions).then(handleResponse);
}
function getDashboard() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/curator/dashboard/all`, requestOptions).then(handleResponse);
}
function deletePiece(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/art/${id}`, requestOptions).then(handleResponse);
}
function getArtist(artistId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist/${artistId}`, requestOptions).then(handleResponse);
}
function getArtists(filter) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  let statusString = '';
  if (filter.status) {
    statusString = filter.status.join('&status[]=');
  }
  return fetch(`${process.env.ROOT_API}/artist${statusString ? `?status[]=${statusString}` : ''}`, requestOptions).then(handleResponse);
}
function getShipment(shipmentid) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/shipment/${shipmentid}`, requestOptions).then(handleResponse);
}
function getOrder(orderId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/order/${orderId}`, requestOptions).then(handleResponse);
}
function getOrderLine(orderLineId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/order-line/${orderLineId}`, requestOptions).then(handleResponse);
}
function getOrderLines(filter) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  let statusString = '';
  if (filter.status) {
    statusString = filter.status.join('&status[]=');
  }
  return fetch(`${process.env.ROOT_API}/order-line${statusString ? `?status[]=${statusString}` : ''}`, requestOptions).then(handleResponse);
}
async function confirmOrderLine(lineId) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/order-line/${lineId}/confirm`, requestOptions).then(handleResponse);
}
function getOrders(filter) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  let statusString = '';
  if (filter.type) {
    statusString = filter.type.join('&type[]=');
  }
  return fetch(`${process.env.ROOT_API}/order${statusString ? `?type[]=${statusString}` : ''}`, requestOptions).then(handleResponse);
}
function getRental(rentalId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/rental/${rentalId}`, requestOptions).then(handleResponse);
}
function getRentals(filter) {
  let filterString = '';
  if (filter) {
    filterString += '?';
    const keys = Object.keys(filter);
    keys.forEach((key) => {
      // Handle array filters
      // filterString += `${key}[]=${filter[key].join(`&${key}[]=`)}`;
      if (filter[key].length > 0) {
        filterString += `${key}[]=${filter[key].join(`&${key}[]=`)}`;
      }
      // } else {
      //   filterString += `&${key}=${filter[key]}`;
      // }
    });
  }
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/rental${filterString}`, requestOptions).then(handleResponse);
}
// function getRentals(filter) {
//   const requestOptions = {
//     method: 'GET',
//     headers: { ...authHeader(), 'Content-Type': 'application/json' },
//   };
//   let statusString = '';
//   if (filter.type) {
//     statusString = filter.type.join('&type[]=');
//   }
//   if (filter.status) {
//     statusString = filter.type.join('&status[]=');
//   }
//   return fetch(`${process.env.ROOT_API}/rental${statusString ? `?type[]=${statusString}` : ''}`, requestOptions).then(handleResponse);
// }
function addCustomer(customer) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(customer),
  };
  return fetch(`${process.env.ROOT_API}/customer`, requestOptions).then(handleResponse);
}
function getAddresses() {
  return fetch('https://ams3.digitaloceanspaces.com/wall.res/resources/addresses.json').then(handleResponse);
}
function getCustomer(id) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/customer/${id}`, requestOptions).then(handleResponse);
}
function getCustomers(filter) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  let statusString = '';
  if (filter.type) {
    statusString = filter.type.join('&type[]=');
  }
  return fetch(`${process.env.ROOT_API}/customer${statusString ? `?type[]=${statusString}` : ''}`, requestOptions).then(handleResponse);
}
function getReport(report) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/report/${report}`, requestOptions).then(handleResponse);
}
function getPayoutEligible(artistId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/payout/eligible/${artistId}`, requestOptions).then(handleResponse);
}
function getPayoutsEligible() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/payout/eligible`, requestOptions).then(handleResponse);
}
function getPayouts() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/payout`, requestOptions).then(handleResponse);
}
function getPayout(payoutId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/payout/${payoutId}`, requestOptions).then(handleResponse);
}
function addPayout(payout) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(payout),
  };
  return fetch(`${process.env.ROOT_API}/payout`, requestOptions).then(handleResponse);
}
function completeOrder(orderId) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/order/${orderId}/complete`, requestOptions).then(handleResponse);
}
function addReturn(returnItem) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(returnItem),
  };
  return fetch(`${process.env.ROOT_API}/return`, requestOptions).then(handleResponse);
}
function updatePayoutPop(file, payoutId) {
  const data = new FormData();
  data.append('file', file);
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader() },
    body: data,
  };
  return fetch(`${process.env.ROOT_API}/payout/pop/${payoutId}`, requestOptions).then(handleResponse);
}
async function addArt(form) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(form),
  };
  return fetch(`${process.env.ROOT_API}/art`, requestOptions).then(handleResponse);
}
async function updateArt(form) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(form),
  };
  return fetch(`${process.env.ROOT_API}/art/${form.id}`, requestOptions).then(handleResponse);
}
function getItems() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/item`, requestOptions).then(handleResponse);
}
async function addItem(item) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(item),
  };
  return fetch(`${process.env.ROOT_API}/item`, requestOptions).then(handleResponse);
}
function updateItem(item) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(item),
  };
  return fetch(`${process.env.ROOT_API}/item`, requestOptions).then(handleResponse);
}
function wasteMyTime() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, 1000);
  });
}
async function reportFault(error) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(error),
  };
  return fetch(`${process.env.ROOT_API}/staff/fault`, requestOptions).then(handleResponse);
}
function getFaqs() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/faq`, requestOptions).then(handleResponse);
}
function getFaqTopics() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/faq/topic`, requestOptions).then(handleResponse);
}
function addFaq(faq) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(faq),
  };
  return fetch(`${process.env.ROOT_API}/faq`, requestOptions).then(handleResponse);
}
function deleteFaq(faqId) {
  const requestOptions = {
    method: 'DELETE',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/faq/${faqId}`, requestOptions).then(handleResponse);
}
async function addOrder(order) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(order),
  };
  return fetch(`${process.env.ROOT_API}/order`, requestOptions).then(handleResponse);
}
async function addCorporateRental(rental) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(rental),
  };
  return fetch(`${process.env.ROOT_API}/curator/rental/corporate`, requestOptions).then(handleResponse);
}
async function cancelOrder(orderId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/order/${orderId}/cancel`, requestOptions).then(handleResponse);
}
function updateShipment(shipment) {
  const requestOptions = {
    method: 'PATCH',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(shipment),
  };
  return fetch(`${process.env.ROOT_API}/shipment/${shipment.id}`, requestOptions).then(handleResponse);
}
async function cancelShipment(shipmentId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/shipment/${shipmentId}/cancel`, requestOptions).then(handleResponse);
}
async function cancelRental(rentalId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/rental/${rentalId}/cancel`, requestOptions).then(handleResponse);
}
async function returnRental(rentalId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/rental/${rentalId}/return`, requestOptions).then(handleResponse);
}
async function convertRental(rentalId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/rental/${rentalId}/convert`, requestOptions).then(handleResponse);
}

// Helper Functions
function handleResponse(response) {
  return response.text().then((text) => {
    const content = text && JSON.parse(text);
    if (!response.ok) {
      // Notify admin of issue
      // reportFault({ url: response.url, message: response.statusText });
      // auto logout if 401 response returned from api
      if (response.status === 401) {
        // INVALID USER GET HIM THE HELL OUT OF HERE!
        store.commit('account/logout');
        location.reload(true);
      }
      const error = (content && content.message) || response.statusText;
      console.log({ error });
      console.log(response);
      return Promise.reject(error);
    }
    return Promise.resolve(content);
  });
}



// WEBPACK FOOTER //
// ./src/services/api.service.js